<template>
    <img src="../../../assets/images/profile.jpg" class="profile-image justify-content-center" width="250" height="250" alt="Loading profile image...">
</template>

<script>
export default {
  name: "ProfileImage",
}
</script>

<style scoped>
.profile-image{
  border-radius: 50%;
  border: 2px solid #232323;
}
</style>